export default __webpack_public_path__ + "static/media/Bosh prokuratura.703f507f.png";